"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBaseButton = void 0;
var _polished = require("polished");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _componentTheme = require("@clds/component-theme");
var _typography = require("@clds/typography");
var _styleUtils = require("@clds/style-utils");
var _toolbarLayout = require("@clds/toolbar-layout");
var _componentEnhancer = require("@clds/component-enhancer");
var _icon = require("@cld/icon");
var _buttonTheme = require("../buttonTheme");
var _StyledProgress = require("./StyledProgress");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//space that added in both sides to make the button a rectangle (when not in "icon only" mode)
const calcRectangleMarginBySize = ({
  size,
  ...props
}) => {
  switch (size) {
    case 'sm':
      return _componentTheme.globalTheme.spacing.xxs(props);
    case 'md':
      return _componentTheme.globalTheme.spacing.xs(props);
    case 'lg':
      return _componentTheme.globalTheme.spacing.sm(props);
    default:
      return '';
  }
};
const focusCss = ({
  shape,
  buttonType
}) => {
  var _buttonTheme$shape, _buttonTheme$shape2, _buttonTheme$shape3;
  const boxShadowStyles = shape && buttonType ? (0, _styledComponents.css)(["box-shadow:0 0 0 3px ", ";"], (0, _componentTheme.combineValues)((_buttonTheme$shape = _buttonTheme.buttonTheme[shape]) === null || _buttonTheme$shape === void 0 || (_buttonTheme$shape = _buttonTheme$shape[buttonType]) === null || _buttonTheme$shape === void 0 || (_buttonTheme$shape = _buttonTheme$shape.focus) === null || _buttonTheme$shape === void 0 ? void 0 : _buttonTheme$shape.color, color => (0, _polished.rgba)(color, 0.5))) : '';
  const borderStyles = shape && buttonType ? (0, _styledComponents.css)(["border-radius:", ";border:1px solid ", ";"], (_buttonTheme$shape2 = _buttonTheme.buttonTheme[shape]) === null || _buttonTheme$shape2 === void 0 || (_buttonTheme$shape2 = _buttonTheme$shape2[buttonType]) === null || _buttonTheme$shape2 === void 0 || (_buttonTheme$shape2 = _buttonTheme$shape2.border) === null || _buttonTheme$shape2 === void 0 ? void 0 : _buttonTheme$shape2.radius, (_buttonTheme$shape3 = _buttonTheme.buttonTheme[shape]) === null || _buttonTheme$shape3 === void 0 || (_buttonTheme$shape3 = _buttonTheme$shape3[buttonType]) === null || _buttonTheme$shape3 === void 0 || (_buttonTheme$shape3 = _buttonTheme$shape3.focus) === null || _buttonTheme$shape3 === void 0 ? void 0 : _buttonTheme$shape3.color) : '';
  return (0, _styledComponents.css)(["&", "{", ";&:before{content:'';position:absolute;width:100%;height:100%;", ";}}"], (0, _styleUtils.focusVisible)(), boxShadowStyles, borderStyles);
};
const shapeCss = ({
  shape,
  buttonType
}) => (0, _styledComponents.css)(["", ";", ";"], () => {
  var _buttonTheme$shape4;
  return shape && buttonType && (0, _styledComponents.css)(["border-radius:", ";"], (_buttonTheme$shape4 = _buttonTheme.buttonTheme[shape]) === null || _buttonTheme$shape4 === void 0 || (_buttonTheme$shape4 = _buttonTheme$shape4[buttonType]) === null || _buttonTheme$shape4 === void 0 || (_buttonTheme$shape4 = _buttonTheme$shape4.border) === null || _buttonTheme$shape4 === void 0 ? void 0 : _buttonTheme$shape4.radius);
}, (0, _toolbarLayout.supportFieldLineLayout)());
const styledBaseButtonCss = ({
  size,
  ...props
}) => {
  var _buttonTheme$shape5;
  const {
    shape,
    buttonType
  } = props;
  const typographyType = (_buttonTheme$shape5 = _buttonTheme.buttonTheme[shape]) === null || _buttonTheme$shape5 === void 0 || (_buttonTheme$shape5 = _buttonTheme$shape5[buttonType]) === null || _buttonTheme$shape5 === void 0 || (_buttonTheme$shape5 = _buttonTheme$shape5.typography) === null || _buttonTheme$shape5 === void 0 ? void 0 : _buttonTheme$shape5.type(props);
  const fontSize = _typography.appsTheme[{
    sm: 'xs',
    md: 'md',
    lg: 'lg'
  }[size]].size(props);
  const padding = _componentTheme.globalTheme.spacing[{
    sm: 'xs',
    md: 'sm',
    lg: 'md'
  }[size]](props);
  const typographyStyle = (0, _typography.typographyMixin)({
    sm: 'xs',
    md: 'md',
    lg: 'lg'
  }[size], typographyType);
  return (0, _styledComponents.css)(["padding:", ";", ";height:calc(", " + ", " + ", ");min-width:calc(", " + ", " + ", ");", "{", "}"], padding, typographyStyle, fontSize, padding, padding, fontSize, padding, padding, _icon.Icon, _icon.iconMixin);
};
const disabledCss = (0, _styledComponents.css)([":disabled{pointer-events:none;opacity:0.25;}"]);
const clickCss = (0, _styledComponents.css)(["cursor:pointer;"]);
const StyledBaseButton = _styledComponents.default.button.withConfig({
  displayName: "StyledBaseButton"
})(["position:relative;display:inline-flex;min-height:-webkit-fit-content;align-items:center;align-content:center;justify-content:center;border:none;outline:none;font-weight:500;margin:0;text-overflow:ellipsis;white-space:nowrap;pointer-events:", ";background-color:transparent;background-clip:padding-box;", ";transition:background-color 350ms,color 350ms,box-shadow 250ms,opacity 250ms;svg path{transition:fill 350ms,stroke 350ms;}", ",", "{&:not(", "){visibility:", ";&:not(:first-child){margin-left:", ";}&:first-child{margin-left:", ";}&:last-child{margin-right:", ";}}}> ", "", "", "{& + ", ":last-child{margin:0;}& + *{margin-left:", ";}}", "", ":disabled{margin:0;}", "", ":only-child{margin:0;}", ";", " ", ";"], ({
  progress
}) => progress ? 'none' : 'auto', styledBaseButtonCss, _icon.Icon, _componentEnhancer.TextWrap, _StyledProgress.StyledProgress, ({
  progress
}) => progress ? 'hidden' : 'inherit', _componentTheme.globalTheme.spacing.xs, calcRectangleMarginBySize, calcRectangleMarginBySize, _StyledProgress.StyledProgress, _StyledProgress.StyledProgress, _StyledProgress.StyledProgress, _icon.Icon, calcRectangleMarginBySize, _icon.Icon, _icon.Icon, _icon.Icon, _icon.Icon, ({
  selected,
  disabled
}) => !selected && !disabled && (0, _styledComponents.css)(["", ";", ";"], clickCss, focusCss), ({
  disabled
}) => disabled && disabledCss, shapeCss);
exports.StyledBaseButton = StyledBaseButton;
//# sourceMappingURL=StyledBaseButton.js.map